








































































































































































































































































































































































































































import Vue from "vue";
import SideBar from "@/parts/about/SideBar.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";

import { getUserProfile } from "@/api/UserProfile";
import { GetUserProfileResponse } from "@/api/dto/UserProfile";

interface Data {
  profileData: GetUserProfileResponse;
}

export default Vue.extend({
  name: "Question",
  components: {
    SideBar,
    ReturnTop,
  },
  data(): Data {
    return {
      profileData: {} as GetUserProfileResponse,
    };
  },
  async beforeRouteEnter(to, from, next) {
    const userProfRes = await getUserProfile();

    next((vm) => {
      (vm.$data as Data).profileData = {
        ...userProfRes,
        userCategory: userProfRes.userCategory ? userProfRes.userCategory : '0',
      };
    });
  },
  methods: {
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = {
          ...res,
          userCategory: res.userCategory ? res.userCategory : '0',
        };
        // ページ離脱時に編集有無を確認するために、現在のプロフィール情報を保持しておく
      } catch (e) {
        console.log(e);
      }
    },
  },
});
